var language = lang === null ? 'en' : lang;

var translation = window['langArr'][window['language']];

window['getCookie'] = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

window['setCookie'] = function(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(document).ready(function () {

    // Determine either back button should be present or not
    getUrlParam('backUrl') ? $('.go-back-btn').css('display', 'flex') : 
        $('.go-back-btn').css('display', 'none');

     /**
     * On Go Back Button Click
     */
    $('.go-back-btn').click(function(e) {
        e.preventDefault();
        // window.open(getUrlParam('backUrl')),"_self";
        window.location.replace(getUrlParam('backUrl'));
    });

    // remove fade class from statistics tab
    $('#statistics-tabbing').removeClass('fade');

    if(window['term'] == 1) {
        $('.game-holder.video, .game-holder.tickets, #help-btn').hide();
    }

    $("#nav-icon1").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("active");
        $(this).toggleClass('open');
    });

    $('#nameInput').attr('placeholder', translation['enter_alias']);

    // Rounds up clicked.
    $('#round-amount-up').on('click', function() {
        var inputVal = parseInt($('#subscription-btn').val());
        inputVal += 1;
        inputVal > 50 ? inputVal = 50 : inputVal;
        $('#subscription-btn').val(inputVal);
    });

    // Rounds down clicked.
    $('#round-amount-down').on('click', function() {
        var inputVal = parseInt($('#subscription-btn').val());
        inputVal -= 1;
        inputVal < 1 ? inputVal = 1 : inputVal;
        $('#subscription-btn').val(inputVal);
    });
    
    /**
     * Toggle fullscreen function who work with webkit and firefox.
    */
    function toggleFullscreen() {
        //var element = document.getElementsByTagName("iframe")[0];
        var element = document.documentElement; 
        
        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
    
        element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
        document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };
    
        isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
    }

    $('.fullscreen-toggler').click(function() {
        toggleFullscreen();
    });

    (function () {
        $(".card").on("show.bs.collapse hide.bs.collapse", function (e) {
            if (e.type == 'show') {
                $(this).children('div:first-child').addClass('card-header-white');
            } else {
                $(this).children('div:first-child').removeClass('card-header-white');
            }
        });
    }).call(this);

    if (window.innerWidth < 992) {
        showTab(window.location.hash);
    }

    setTimeout( function() {
      document.getElementsByClassName('game-holder statistics')[0].style.overflowY = "auto";
      document.getElementsByClassName('game-holder statistics')[0].style.overflowX = "hidden";
      if (document.getElementsByClassName("game-holder betting")[0] !== undefined) {
        if (document.getElementsByClassName("game-holder betting")[0].scrollHeight != 0) {
          document.getElementsByClassName(
            "game-holder statistics"
          )[0].style.height =
            document.getElementsByClassName("game-holder betting")[0]
              .scrollHeight + "px";
        }
      } else {
        document.getElementsByClassName(
          "game-holder statistics"
        )[0].style.height = "800px";
      }
    }, 3000);

    $(window).resize(function (event) {

      // adapt results tab with left bet tab 
      document.getElementsByClassName('game-holder statistics')[0].style.overflow = "scroll";
      if (document.getElementsByClassName("game-holder betting")[0] !== undefined && 
          document.getElementsByClassName("game-holder betting")[0].scrollHeight != 0) {
            document.getElementsByClassName('game-holder statistics')[0].style.height = 
              document.getElementsByClassName("game-holder betting")[0].scrollHeight + "px";
      }
        if (window.innerWidth >= 992) {
            $('#ticketsXl').show();
            $('#bettingXl').show();
            $('#statisticsXl').show();

            if (window.innerWidth >= 1600) {
                $('#statisticAll').show();
                $('#statisticFirst').show();
                $('#statisticLast').show();
            } else {
                // 992 - 1600
                $('#statisticAll').show();
                $('#statisticFirst').hide();
                $('#statisticLast').hide();
            }

        } else {
            showTab(window.location.hash);
            $('#statisticAll').show();
            $('#statisticFirst').show();
            $('#statisticLast').show();
        }
    });

    $('.ui-tabs-tab').click(function () {
        $(this).addClass('ui-tabs-active ui-state-active');
        showTab($(this).find('a').attr('href'));
    });

    $('#all-accord').click(function () {
        $('.game-bar-md').removeClass('game-bar-md-active');
        $(this).addClass('game-bar-md-active');
        $('#statisticAll').show();
        $('#statisticFirst').hide();
        $('#statisticLast').hide();
    });

    $('#first-accord').click(function () {
        $('.game-bar-md').removeClass('game-bar-md-active');
        $(this).addClass('game-bar-md-active');
        $('#statisticAll').hide();
        $('#statisticFirst').show();
        $('#statisticLast').hide();
    });

    $('#last-accord').click(function () {
        $('.game-bar-md').removeClass('game-bar-md-active');
        $(this).addClass('game-bar-md-active');
        $('#statisticAll').hide();
        $('#statisticFirst').hide();
        $('#statisticLast').show();
    });

    $("[data-langName]").map(function () {
        langName = $(this).attr('data-langName');
        $(this).text(langArr[language][langName]);
    });

    // Tutorial script
    $(".tutorial-close span").click(function () {
        $("body, html").animate({
            scrollTop: 0
        }, 800);
        $(".betting-holder-left").css('z-index', 0);
        $(".betting-holder-right").css('z-index', 0);
        $(".tutorial-show-4").css('z-index', 0);
        $(".tutorial-show-4").css('padding', '0px');
        $(".tutorial-show-5").css('z-index', 0);
        $(".tutorial-show-5").css('padding', '0px');
        $(".tutorial-show-6").css('z-index', 0);
        $(".tickets").css('z-index', 0);
        $(".video").css('z-index', 0);
        $(".statistics").css('z-index', 0);
        $("#tutorial").fadeOut(500);
        if (window.innerWidth <= 768) {
            $(".tickets-tab").removeClass('ui-tabs-active ui-state-active');
            $(".tickets-tab").css('z-index', 0);
            $(".statistics-tab").removeClass('ui-tabs-active ui-state-active');
            $(".statistics-tab").css('z-index', 0);
            $(".betting-tab").css('z-index', 0);
            $('#ticketsXl').hide();
            $('#statisticsXl').hide();
            $('#bettingXl').show();
        }
        $("#tutorial-2").hide();
        $("#tutorial-3").hide();
        $("#tutorial-4").hide();
        $("#tutorial-5").hide();
        $("#tutorial-6").hide();
        $("#tutorial-7").hide();
        $("#tutorial-8").hide();
        $("#tutorial-9").hide();
        $("#tutorial-1").show(500);
        return;
    });

    if(getCookie('visited') == "true" || window['help'] == 0) {
        $("#tutorial").hide();
        $(".tutorial-close span").trigger('click');
    } else {
        setCookie('visited','true',365);
    }

    $("#help-btn").click(function (){
        $("#tutorial").fadeIn(300);
    });

    $("#tutorial-next-1 span").click(function () {
        $("#tutorial-1").fadeOut(100);
        $("body, html").animate({
            scrollTop: $(".betting").offset().top - 20
        }, 800);

        $(".betting-holder-left").css('z-index', 3);
        $("#tutorial-2").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-2 span").click(function () {
        $("#tutorial-2").fadeOut(100);
        $("body, html").animate({
            scrollTop: 0
        }, 800);
        $(".betting-holder-left").css('z-index', 0);
        $("#tutorial-1").fadeIn(1000);
        return;
    });

    $("#tutorial-next-2 span").click(function () {
        $("#tutorial-2").fadeOut(100);
        $(".betting-holder-left").css('z-index', 0);
        $("body, html").animate({
            scrollTop: $(".betting-holder-right").offset().top -200
        }, 800);
        $(".betting-holder-right").css('z-index', 3);
        $("#tutorial-3").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-3 span").click(function () {
        $("#tutorial-3").fadeOut(100);
        $(".betting-holder-right").css('z-index', 0);
        $("body, html").animate({
            scrollTop: $(".betting-holder-left").offset().top -200
        }, 800);
        $(".betting-holder-left").css('z-index', 3);
        $("#tutorial-2").fadeIn(1000);
        return;
    });

    $("#tutorial-next-3 span").click(function () {
        $("#tutorial-3").fadeOut(100);
        $(".betting-holder-right").css('z-index', 0);
        $("body, html").animate({
            scrollTop: $(".betting").offset().top -20
        }, 800);
        $(".tutorial-show-4").css('z-index', 3);
        $(".tutorial-show-4").css('padding', '3px');
        $("#tutorial-4").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-4 span").click(function () {
        $("#tutorial-4").fadeOut(100);
        $(".tutorial-show-4").css('z-index', 0);
        $(".tutorial-show-4").css('padding', '0px');
        $(".betting-holder-right").css('z-index', 3);
        $("#tutorial-3").fadeIn(1000);
        return;
    });

    $("#tutorial-next-4 span").click(function () {
        $("#tutorial-4").fadeOut(100);
        $(".tutorial-show-4").css('z-index', 0);
        $(".tutorial-show-4").css('padding', '0px');
        $(".tutorial-show-5").css('z-index', 3);
        $(".tutorial-show-5").css('padding', '3px');
        $("#tutorial-5").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-5 span").click(function () {
        $("#tutorial-5").fadeOut(100);
        $(".tutorial-show-5").css('z-index', 0);
        $(".tutorial-show-5").css('padding', '0px');
        $(".tutorial-show-4").css('z-index', 3);
        $(".tutorial-show-4").css('padding', '3px');
        $("#tutorial-4").fadeIn(1000);
        return;
    });

    $("#tutorial-next-5 span").click(function () {
        $("#tutorial-5").fadeOut(100);
        $(".tutorial-show-5").css('z-index', 0);
        $(".tutorial-show-5").css('padding', '0px');
        $(".tutorial-show-6").css('z-index', 3);
        $("#tutorial-6").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-6 span").click(function () {
        $("#tutorial-6").fadeOut(100);
        $(".tutorial-show-6").css('z-index', 0);
        $(".tutorial-show-5").css('z-index', 3);
        $(".tutorial-show-5").css('padding', '3px');
        $("#tutorial-5").fadeIn(1000);
        return;
    });

    $("#tutorial-next-6 span").click(function () {
        $("#tutorial-6").fadeOut(100);
        $(".tutorial-show-6").css('z-index', 0);
        $("body, html").animate({
            scrollTop: 0
        }, 800);
        $(".tickets").css('z-index', 3);
        if (window.innerWidth <= 768) {
            $('#bettingXl').hide();
            $(".tickets-tab").css('z-index', 3);
            $(".tickets-tab").addClass('ui-tabs-active ui-state-active');
            $('#ticketsXl').show();
        }
        $("#tutorial-7").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-7 span").click(function () {
        $("#tutorial-7").fadeOut(100);
        $(".tickets").css('z-index', 0);
        $(".tickets-tab").css('z-index', 0);
        if (window.innerWidth <= 768) {
            $(".tickets-tab").removeClass('ui-tabs-active ui-state-active');
            $('#ticketsXl').hide();
            $('#bettingXl').show();
        }
        $("body, html").animate({
            scrollTop: $(".betting").offset().top - 20
        }, 800);
        $(".tutorial-show-6").css('z-index', 3);
        $("#tutorial-6").fadeIn(1000);
        return;
    });

    $("#tutorial-next-7 span").click(function () {
        $("#tutorial-7").fadeOut(100);
        $(".tickets").css('z-index', 0);
        if (window.innerWidth <= 768) {
            $(".tickets-tab").removeClass('ui-tabs-active ui-state-active');
            $(".tickets-tab").css('z-index', 0);
            $('#ticketsXl').hide();
            $('#bettingXl').show();
        }
        $(".video").css('z-index', 3);
        $("#tutorial-8").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-8 span").click(function () {
        $("#tutorial-8").fadeOut(100);
        $(".video").css('z-index', 0);
        if (window.innerWidth <= 768) {
            $('#bettingXl').hide();
            $(".tickets-tab").css('z-index', 3);
            $(".tickets-tab").addClass('ui-tabs-active ui-state-active');
            $('#ticketsXl').show();
        }
        $(".tickets").css('z-index', 3);
        $("#tutorial-7").fadeIn(1000);
        return;
    });

    $("#tutorial-next-8 span").click(function () {
        $("#tutorial-8").fadeOut(100);
        $(".video").css('z-index', 0);
        $("body, html").animate({
            scrollTop: $(".statistics").offset().top - 20
        }, 800);
        if (window.innerWidth <= 768) {
            $('#bettingXl').hide();
            $(".statistics-tab").css('z-index', 3);
            $(".statistics-tab").addClass('ui-tabs-active ui-state-active');
            $('#statisticsXl').show();
        }
        $(".statistics").css('z-index', 3);
        $("#tutorial-9").fadeIn(1000);
        return;
    });

    $("#tutorial-prev-9 span").click(function () {
        $("#tutorial-9").fadeOut(100);
        $(".statistics").css('z-index', 0);
        $("body, html").animate({
            scrollTop: 0
        }, 800);
        if (window.innerWidth <= 768) {
            $('#statisticsXl').hide();
            $(".statistics-tab").css('z-index', 0);
            $(".statistics-tab").removeClass('ui-tabs-active ui-state-active');
            $('#bettingXl').show();
        }
        $(".video").css('z-index', 3);
        $("#tutorial-8").fadeIn(1000);
        return;
    });

    $('[data-tabBody="betting"]').show();

    $('#terminal-tab-menu ul li a').click(function(e) {
        e.preventDefault();
        var selectedTab = $(this).data('tab');
        $('#terminal-tab-menu ul li').removeClass('selected');
        $(this).parent().addClass('selected');
        $('.terminal-content-tab').hide();
        $('[data-tabBody="'+selectedTab+'"]').show();
        console.log(selectedTab);
    });

    $('.chat-button').click(function(){
        $('.chat-window').show();
    })

    $('#chat-minimize').click(function(){
        $('.chat-window').hide();
    });

});

window.redirectToUrl = function(game, terminal = false) {

    window['token'] = getUrlParam('token');
    window['lang'] = getUrlParam('lang') !== null ? getUrlParam('lang') : 'en';

    if (!terminal) {
        if (getUrlParam('backUrl')) {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang + '&backUrl=' + getUrlParam('backUrl');
        } else {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang;
        }
    } else {
        window.location.href = game + '/terminal.html?token=' + token + '&lang=' + lang;
    }
}

if (window['lang'] == 'rs' || window['lang'] == 'sr' || window['lang'] == 'cnr' || window['lang'] == 'hr' || window['lang'] == 'ba') {
    $('#terCombs6').css('background-image', 'url(' + BASE_URL + GAMES[1].url + '/img/combos-sr/7.png)');
    $('#terCombs28').css('background-image', 'url(' + BASE_URL + GAMES[1].url + '/img/combos-sr/28.png)');
    $('#terCombs81').css('background-image', 'url(' + BASE_URL + GAMES[1].url + '/img/combos-sr/84.png)');
    $('#terCombs201').css('background-image', 'url(' + BASE_URL + GAMES[1].url + '/img/combos-sr/210.png)');
}

window.getUrlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}

window.showTab = function (hash) {
    if ("undefined" === typeof hash || '' == hash) {
        hash = '#betting-tab';
    }

    $('.ui-tabs-tab').removeClass('ui-tabs-active ui-state-active');
    var targetTab = hash.replace('#', '.');
    $(targetTab).addClass('ui-tabs-active ui-state-active');

    switch (hash) {
        case '#betting-tab':
            $('#ticketsXl').hide();
            $('#bettingXl').show();
            $('#statisticsXl').hide();
            break;
        case '#tickets-tab':
            $('#ticketsXl').show();
            $('#bettingXl').hide();
            $('#statisticsXl').hide();
            break;
        case '#statistics-tab':
            $('#ticketsXl').hide();
            $('#bettingXl').hide();
            $('#statisticsXl').show();
            break;
    }

}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/script.js
// module id = 867
// module chunks = 0